export const MIN_SHOW_TAGS = 10;
